module.exports = __webpack_public_path__ + "1383e57eb85ca99948e7ed69efbc1a76.woff2";